import { COUNTRY_OPTIONS, normalizeCountryCallingCode } from "config/locationConfig";

export const PHONE_DIGIT_LENGTH = 10;

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const getCountryCodeOptions = (currentCode) => {
  const options = COUNTRY_OPTIONS.map((country) => ({
    value: country.countryCode,
    label: `${country.countryCode} ${country.label}`
  }));
  const normalizedCurrentCode = normalizeCountryCallingCode(currentCode);

  if (normalizedCurrentCode && !options.some((option) => option.value === normalizedCurrentCode)) {
    options.push({ value: normalizedCurrentCode, label: normalizedCurrentCode });
  }

  return options;
};

export const normalizeContactPhone = (value, countryCode = "") => {
  const rawValue = String(value || "");
  let digits = rawValue.replace(/\D/g, "");
  const countryDigits = normalizeCountryCallingCode(countryCode).replace(/\D/g, "");

  if (countryDigits && digits.length > PHONE_DIGIT_LENGTH) {
    if (digits.startsWith(`00${countryDigits}`)) {
      digits = digits.slice(countryDigits.length + 2);
    } else if (digits.startsWith(countryDigits)) {
      digits = digits.slice(countryDigits.length);
    }
  } else if (!countryDigits && digits.length > PHONE_DIGIT_LENGTH && rawValue.includes("+")) {
    digits = digits.slice(-PHONE_DIGIT_LENGTH);
  }

  digits = digits.replace(/^0+/, "");

  if (digits.length > PHONE_DIGIT_LENGTH) {
    digits = digits.slice(0, PHONE_DIGIT_LENGTH);
  }

  return digits;
};

export const formatContactPhoneInput = (value, countryCode = "") => {
  const digits = normalizeContactPhone(value, countryCode);
  const normalizedCode = normalizeCountryCallingCode(countryCode);

  if (!digits) return "";

  if (normalizedCode === "+1") {
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)} ${digits.slice(5)}`;
};

export const validateEmailAddress = (value, { required = true } = {}) => {
  const email = String(value || "").trim();
  if (!email) return !required;
  return EMAIL_REGEX.test(email);
};

export const validateContactPhone = (value, {
  countryCode = "",
  required = true
} = {}) => {
  const digits = normalizeContactPhone(value, countryCode);
  if (!digits) return !required;
  return digits.length === PHONE_DIGIT_LENGTH;
};

export const getEmailValidationMessage = (value, {
  required = true,
  requiredMessage = "Email is required.",
  invalidMessage = "Please enter a valid email address."
} = {}) => {
  const email = String(value || "").trim();
  if (!email) return required ? requiredMessage : "";
  return validateEmailAddress(email, { required }) ? "" : invalidMessage;
};

export const getContactPhoneValidationMessage = (value, {
  countryCode = "",
  required = true,
  requiredMessage = "Phone number is required.",
  invalidMessage = "Please enter a valid 10-digit phone number."
} = {}) => {
  const digits = normalizeContactPhone(value, countryCode);
  if (!digits) return required ? requiredMessage : "";
  return digits.length === PHONE_DIGIT_LENGTH ? "" : invalidMessage;
};
